import React from 'react';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import Checkbox from '@mui/material/Checkbox';
import { ReactComponent as UncheckedIcon } from './icons/unchecked.svg';
import { ReactComponent as CheckedIcon } from './icons/checked.svg';
import Typography from '@mui/material/Typography';
import { nonTourMarkers, tourMarkers } from '../../constants/markers';

const Filters = ({ selectedMarkers, toggleMarker }) => {
  const handleListItemClick = (value) => {
    toggleMarker(value);
  };

  const getMarkerListItems = (markers) =>
    markers.map(({ key, icon, name }) => {
      return (
        <ListItem
          disablePadding
          onClick={() => {
            handleListItemClick(key);
          }}
          key={key}
          selected={selectedMarkers.includes(key)}
        >
          <ListItemButton disableGutters dense>
            <ListItemIcon className='checkbox'>
              <Checkbox
                edge='start'
                checked={selectedMarkers.includes(key)}
                tabIndex={-1}
                disableRipple
                inputProps={{ 'aria-labelledby': 'ff' }}
                color='success'
                icon={<UncheckedIcon />}
                checkedIcon={<CheckedIcon />}
              />
            </ListItemIcon>
            <ListItemIcon>
              <img src={icon} alt={name} />
            </ListItemIcon>
            <ListItemText primary={name} />
          </ListItemButton>
        </ListItem>
      );
    });

  return (
    <Box className='filters'>
      <Typography variant='h2' component='h2'>
        Filters
      </Typography>
      <List disablePadding>{getMarkerListItems(nonTourMarkers)}</List>
      <Typography variant='h2' component='h2'>
        360° Tours
      </Typography>
      <List disablePadding>{getMarkerListItems(tourMarkers)}</List>
    </Box>
  );
};

export default Filters;
